import { useEffect, useMemo, useRef, useState } from "react";
import {
  CarouselWrap,
  CarouselInner,
  CarouselItem,
  ArrowsWrap,
  ArrowBtn,
} from "./CarouselStyles";

export default function Carousel({ images = [], startIndex = 0, onChange }) {
  const [current, setCurrent] = useState(startIndex);
  const [dragging, setDragging] = useState(false);
  const startX = useRef(0);
  const deltaX = useRef(0);

  const items = useMemo(() => {
    return (images || [])
      .map((it) => (typeof it === "string" ? { src: it, alt: "" } : it))
      .filter((it) => it && it.src);
  }, [images]);

  const len = items.length;

  useEffect(() => {
    if (len === 0) return;
    setCurrent((i) => Math.max(0, Math.min(i, len - 1)));
  }, [len]);

  useEffect(() => {
    if (typeof onChange === "function") onChange(current);
  }, [current, onChange]);

  const next = () => len > 0 && setCurrent((i) => (i + 1) % len);
  const prev = () => len > 0 && setCurrent((i) => (i - 1 + len) % len);

  // ---- Swipe / Drag ----
  const onDown = (clientX) => {
    setDragging(true);
    startX.current = clientX;
    deltaX.current = 0;
  };
  const onMove = (clientX) => {
    if (!dragging) return;
    deltaX.current = clientX - startX.current;
  };
  const onUp = () => {
    if (!dragging) return;
    setDragging(false);
    const threshold = window.innerWidth * 0.12; // ~12% din lățime
    if (deltaX.current > threshold) prev();
    else if (deltaX.current < -threshold) next();
    deltaX.current = 0;
  };

  if (len === 0) return null;

  return (
    <CarouselWrap
      onMouseLeave={onUp}
      onMouseUp={onUp}
      onTouchEnd={onUp}
      onTouchCancel={onUp}
    >
      <CarouselInner
        $index={current}
        $dragging={dragging}
        onMouseDown={(e) => onDown(e.clientX)}
        onMouseMove={(e) => onMove(e.clientX)}
        onTouchStart={(e) => onDown(e.touches[0].clientX)}
        onTouchMove={(e) => onMove(e.touches[0].clientX)}
      >
        {items.map((it, i) => (
          <CarouselItem key={i} $active={i === current}>
            <img src={it.src} alt={it.alt || `slide-${i}`} draggable={false} />
          </CarouselItem>
        ))}
      </CarouselInner>

      {len > 1 && (
        <ArrowsWrap>
          <ArrowBtn aria-label="Previous" onClick={prev}>
            ‹
          </ArrowBtn>
          <ArrowBtn aria-label="Next" onClick={next}>
            ›
          </ArrowBtn>
        </ArrowsWrap>
      )}
    </CarouselWrap>
  );
}
